var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMountain04Landscape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 3543.56,
    height: 5102.84,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3543.56 5102.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".n{fill:url(#e);}.o{fill:url(#d);}.p{fill:url(#g);}.q{fill:url(#f);}.r{fill:url(#i);}.s{fill:url(#h);}.t{fill:url(#k);}.u{fill:url(#j);}.v{fill:url(#m);}.w{fill:url(#l);}.x{fill:url(#c);}.y{fill:#f7f7f2;}.a`{fill:#0cf;}.aa{fill:#317664;}.ab{fill:#18413d;}.ac{fill:#408a67;}.ad{fill:#366541;}.ae{fill:#88c163;}.af{fill:#85bf63;}.ag{fill:#2a5254;}.ah{fill:#34635b;}.ai{fill:#568a5c;}.aj{fill:#61b76c;}.ak{fill:#5fb46c;}.al{fill:#4c9b69;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 4251.2,
    y1: 1617.76,
    x2: 4397.26,
    y2: 1195.13,
    gradientTransform: "translate(1623.98 1867.96) scale(.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#317664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61b76c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 2374.54,
    y1: 3130.55,
    x2: 2374.54,
    y2: 1674.06,
    gradientTransform: "translate(1623.98 1867.96) scale(.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#317664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61b76c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 2336.67,
    y1: 2516.94,
    x2: 1014.67,
    y2: 1564.39,
    gradientTransform: "translate(1623.98 1867.96) scale(.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57a96a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -669.87,
    y1: 1781.32,
    x2: -745.02,
    y2: 2860.5,
    gradientTransform: "translate(1623.98 1867.96) scale(.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88c163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e9e69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 652.47,
    y1: 1417.01,
    x2: 507.14,
    y2: 3406.23,
    gradientTransform: "translate(1623.98 1867.96) scale(.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#317664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61b76c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -608.59,
    y1: 1979.2,
    x2: -498.65,
    y2: 2890.31,
    gradientTransform: "translate(1623.98 1867.96) scale(.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57a96a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 3718.29,
    y1: 2271.01,
    x2: 3207.62,
    y2: 3769.84,
    gradientTransform: "translate(1623.98 1867.96) scale(.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88c163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5db26b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 4687.47,
    y1: 2748.27,
    x2: 3645.85,
    y2: 4564.03,
    gradientTransform: "translate(1623.98 1867.96) scale(.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88c163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5db26b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 7010.66,
    y1: 2069.23,
    x2: 5987.1,
    y2: 3911.47,
    gradientTransform: "translate(1623.98 1867.96) scale(.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88c163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e9e69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -2764.91,
    y1: 4627.7,
    x2: -2312.33,
    y2: 2849.6,
    gradientTransform: "translate(1623.98 1867.96) scale(.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#317664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61b76c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: -1656.97,
    y1: 2639.26,
    x2: -5307.94,
    y2: 3208.21,
    gradientTransform: "translate(1623.98 1867.96) scale(.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92ab7c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "2894.29 2429.14 2719.89 2429.14 2834.39 2278.54 2899.69 2259.44 2954.19 2278.54 3068.69 2429.14 2894.29 2429.14",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2834.39,2278.54l59.9-78.7,60,78.9c-7.4-3.1-13.8-1.4-16.1,5.1-3.7,10.8-17.5,15.2-28,1.9-10.6-13.2-22.8-8.5-30.2,1-7.4,9.5-25.3,13.3-33.2-1-3.4-6-8.2-7.4-12.4-7.2Z",
    style: {
      fill: "#f7f7f2"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "2605.59 2562.14 2530.29 2229.34 2454.99 2562.14 2605.59 2562.14",
    style: {
      fill: "#568a5c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2683.29 2617.14 2604.39 2268.44 2525.49 2617.14 2683.29 2617.14",
    style: {
      fill: "#2a5254"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2435.79 2584.24 2371.59 2300.74 2307.49 2584.24 2435.79 2584.24",
    style: {
      fill: "#88c163"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2774.09 2507.74 2717.99 2299.54 2661.99 2507.74 2774.09 2507.74",
    style: {
      fill: "#568a5c"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "222.19 2565.74 146.99 2233.04 71.59 2565.74 222.19 2565.74",
    style: {
      fill: "#568a5c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.09 2527.54 286.69 2242.84 222.19 2527.54 351.09 2527.54",
    style: {
      fill: "#2a5254"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.49 2644.44 70.29 2360.84 30.99 2534.64 30.99 2644.44 134.49 2644.44",
    style: {
      fill: "#88c163"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.39 2496.94 348.29 2288.54 301.19 2496.94 395.39 2496.94",
    style: {
      fill: "#568a5c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1614.49,2639.64s214.1-315.9,642.3-245.7c336.2,55.1,687.1,391.5,822.3,533.4H1673.79l-59.3-287.7Z",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1614.49,2639.64s57.4-84.7,172.3-156.6c312.1,87.9,561.5,309.4,831.9,444.4h-944.9l-59.3-287.8Z",
    style: {
      fill: "#408a67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1834.09,2455.94c7.5-3.9,15.2-7.7,23.2-11.4-32,22.5-62.7,48.7-91.9,77.6-51.4,50.8-98.3,109.9-139.8,171.5l-1.3-6.2c41.1-60.6,87.4-118.5,137.9-168.5,23.1-22.8,47.2-44,71.9-63Zm159.4-57.3c8.1-1.7,16.3-3.3,24.7-4.8-74.6,26.8-144.5,76.2-208,137.7-65.1,63.2-123.5,139.2-173.1,217.2l-1.3-6.4c49.3-76.8,107-151.7,171.3-214.1,57.2-55.5,119.8-101.2,186.4-129.6Zm115.3-14.3c9.3-.4,18.9-.6,28.5-.5-103.5,14.2-199.7,74.6-284.4,156.8-79,76.7-148,172.3-203.7,267.1l-1.3-6.6c55.5-93.8,123.8-187.9,201.9-263.7,77.6-75.5,165-132.7,259-153.1Zm87.4,2c9.9,.8,19.9,1.9,30.1,3.2-121.2,.1-233.6,65.7-330.8,160-93.8,91-173.5,208.8-233.6,320.2l-1.4-6.9c60-110.4,139-226.5,231.9-316.6,89.9-87.2,192.7-150,303.8-159.9Zm62.2,7.9c8.2,1.4,16.5,3,24.8,4.6-126.6-5.3-243.9,61.7-344.9,159.7-107.5,104.4-196.6,243.9-258.8,368.9h-5.1c62.4-125.8,152.1-266.7,260.7-372.1,95.2-92.4,204.8-157.4,323.3-161.1Zm44.2,8.9c6.1,1.5,12.1,3,18.1,4.6-124.6-3.3-240.1,63.1-339.8,159.8-105,101.9-192.4,237.3-254.3,359.9h-5.1c62.2-123.5,150.3-260.3,256.3-363.1,95.6-92.8,205.8-157.9,324.8-161.2Zm35.4,9.3c4.6,1.3,9.3,2.7,13.9,4.2-120.3,1-231.6,66.3-328.1,160-102.4,99.4-188.1,230.7-249.7,350.9h-5.1c61.9-121.1,148.2-253.8,251.7-354.1,93.5-90.9,201-155.3,317.3-161Zm31.3,9.7c3.7,1.2,7.4,2.5,11.1,3.8-114.8,5.7-221.3,69.5-314,159.5-99.9,96.9-183.8,224.1-245,341.9h-5.1c61.6-118.7,146.2-247.3,247-345.1,90.5-87.8,194.1-150.9,306-160.1Zm29.4,10.4c3.1,1.1,6.2,2.4,9.3,3.5-109.1,10.4-210.2,72.5-298.9,158.4-97.4,94.5-179.5,217.8-240.3,332.9h-5.1c61.1-116.1,144-240.8,242.3-336.2,86.9-84.2,185.9-145.8,292.7-158.6Zm28.2,11c2.7,1.1,5.4,2.2,8.1,3.4-103,14.5-198.8,74.7-283.1,156.6-94.9,92-175.3,211.4-235.6,323.9h-5.1c60.6-113.6,141.7-234.2,237.5-327.2,83-80.5,177-140.3,278.2-156.7Zm27.7,11.7c2.4,1,4.8,2.1,7.2,3.2-97,18.2-187.2,76.4-267.2,154-92.3,89.6-171,205-230.7,314.9h-5.2c60.1-110.9,139.5-227.7,232.7-318.2,78.9-76.4,167.7-134.2,263.2-153.9Zm27.3,12.5c2.1,1,4.3,2.1,6.5,3.1-90.9,21.3-175.5,77.3-251.1,150.6-89.8,87.1-166.7,198.7-225.8,305.9h-5.2c59.5-108.2,137.1-221.1,227.8-309.2,74.6-72.3,158.1-127.9,247.8-150.4Zm27.1,13.3c2,1,3.9,2,5.9,3-84.7,23.9-163.8,77.5-234.8,146.4-87.3,84.8-162.4,192.6-220.8,297h-5.2c58.8-105.5,134.6-214.6,222.8-300.2,70.3-68.2,148.4-121.5,232.1-146.2Z",
    style: {
      fill: "#5fb46c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1806.19,2510.14c.3-.3,92.1-79.7,214.2-31.7l12.3,4.8c107.5,42.4,146.7,57.8,244.8,7.2,53.3-27.6,101.4-34.3,144.9-26.9,43.4,7.4,82.1,28.9,116.8,57.9l-7.6,9.1c-33.2-27.7-70.1-48.3-111.1-55.3s-86.6-.5-137.4,25.8c-103,53.1-143.5,37.1-254.7-6.6l-12.3-4.8c-115.4-45.4-201.8,29.4-202.1,29.6l-7.8-9.1Z",
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "1462.59 2508.64 1527.49 2221.54 1592.39 2508.64 1462.59 2508.64",
    style: {
      fill: "#366541"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1446.29 2471.54 1493.29 2263.94 1540.29 2471.54 1446.29 2471.54",
    style: {
      fill: "#2a5254"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1578.19 2535.24 1624.79 2329.34 1671.39 2535.24 1578.19 2535.24",
    style: {
      fill: "#18413d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1623.19 2564.14 1667.99 2366.14 1712.79 2564.14 1623.19 2564.14",
    style: {
      fill: "#568a5c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2010.49 2672.24 2048.69 2503.54 2086.79 2672.24 2010.49 2672.24",
    style: {
      fill: "#366541"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1716.49 2550.34 1750.79 2398.44 1785.29 2550.34 1716.49 2550.34",
    style: {
      fill: "#2a5254"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1800.79 2565.84 1834.09 2418.84 1867.29 2565.84 1800.79 2565.84",
    style: {
      fill: "#2a5254"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1891.19 2588.14 1922.49 2449.84 1953.79 2588.14 1891.19 2588.14",
    style: {
      fill: "#34635b"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.99,2586.54c168.1-117,477.2-263.5,935.8-219.8,737.1,70.2,1754.9,701.9,1754.9,701.9v421.1H30.99v-903.2Z",
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.99,2586.54c23.6-16.4,50-33.4,79.2-50.4,616.1-144.4,1395.6,286.3,1461.2,443v510.6H30.99v-903.2Z",
    style: {
      fill: "#4c9b69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.89,2537.54c3.3-1.9,6.6-3.9,10-5.8,147.7,20.8,289.5,99.1,418.4,206.7,238.5,198.9,433.2,498.2,540.1,718.3,.8,1.7,.1,3.9-1.7,4.7-1.7,.8-3.8,.1-4.6-1.7-106.6-219.4-300.7-517.7-538.3-715.9-130.6-109-274.4-187.7-423.9-206.3Zm38.4-21.5c3.7-2,7.5-4.1,11.4-6.1,156.8,15,307.4,96,443.6,209.7,238.4,198.9,433.1,498.1,540,718.2,.9,1.8,.1,3.9-1.6,4.7-1.7,.9-3.9,.1-4.7-1.6-106.6-219.4-300.7-517.7-538.2-715.9-138.4-115.6-291.5-197-450.5-209Zm39.2-20.3c4.5-2.1,9-4.4,13.5-6.5,165.3,8.7,324.2,92,467.3,211.4,238.5,198.9,433.2,498.2,540.1,718.3,.8,1.7,.1,3.9-1.7,4.7-1.7,.8-3.8,.1-4.6-1.7-106.6-219.4-300.7-517.7-538.3-715.9-145.8-121.6-307.9-205.5-476.3-210.3Zm40.6-18.9c5.3-2.4,10.7-4.8,16.1-7.1,173.2,2.1,339.8,87.5,489.3,212.2,238.4,198.9,433.1,498.1,540.1,718.2,.8,1.8,.1,3.9-1.7,4.7-1.7,.9-3.9,.1-4.7-1.6-106.7-219.5-300.7-517.8-538.2-716-153-127.6-323.9-213.7-500.9-210.4Zm42.1-18c6.5-2.7,13.2-5.3,19.9-7.9,180-4.3,353.4,82.7,508.3,212,238.5,198.9,433.2,498.2,540.1,718.3,.8,1.7,.1,3.9-1.7,4.7-1.7,.8-3.8,.1-4.6-1.7-106.6-219.4-300.7-517.7-538.3-715.9-159.4-133.1-338.5-221-523.7-209.5Zm44.9-17.2c8.4-3,17-6.1,25.6-9,185.2-9.4,363.8,78.7,522.9,211.5,238.5,198.9,433.1,498.1,540.1,718.3,.8,1.7,.1,3.8-1.7,4.6-1.7,.9-3.9,.1-4.7-1.6-106.6-219.4-300.7-517.7-538.2-715.9-165.3-138-351.6-227.4-544-207.9Zm50.7-17.2c11.1-3.5,22.6-7,34.1-10.3,187.2-11.6,367.9,77,528.6,211.1,238.5,198.9,433.2,498.2,540.1,718.3,.8,1.7,.1,3.9-1.7,4.7-1.7,.8-3.8,.1-4.6-1.7-106.6-219.4-300.7-517.7-538.3-715.9-169.3-141.3-360.7-231.7-558.2-206.2Zm65.6-18.9c14.5-3.8,29.2-7.4,44.2-10.8,183.4-7.7,360.3,80.1,518,211.7,238.5,198.9,433.1,498.1,540.1,718.2,.8,1.8,.1,3.9-1.7,4.7-1.7,.9-3.9,.1-4.7-1.6-106.6-219.4-300.7-517.7-538.2-715.9-169.2-141.3-360.4-231.6-557.7-206.3Zm99.6-22.2c15.3-2.8,30.9-5.4,46.7-7.8,170.2,4.6,334,89.3,481,212,238.5,198.9,433.2,498.2,540.1,718.3,.8,1.7,.1,3.9-1.6,4.7-1.8,.8-3.9,.1-4.7-1.7-106.6-219.4-300.7-517.7-538.3-715.9-159.3-133-338.1-220.9-523.2-209.6Zm135.9-18.4c12.7-1.1,25.6-2.1,38.6-3,147.6,20.8,289.4,99.2,418.2,206.7,238.5,198.9,433.1,498.1,540.1,718.2,.8,1.8,.1,3.9-1.7,4.7-1.7,.9-3.9,.1-4.7-1.6-106.6-219.4-300.7-517.7-538.2-715.9-138.8-115.9-292.5-197.6-452.3-209.1Zm150.5-6c10.2,.1,20.6,.2,31,.5,119.6,33.2,234.3,101.9,340.4,190.3,238.5,198.9,433.2,498.2,540.1,718.3,.8,1.7,.1,3.9-1.6,4.7-1.8,.8-3.9,.1-4.7-1.7-106.6-219.4-300.7-517.7-538.3-715.9-113.9-95-237.8-167-366.9-196.2Zm154,8.1c8.6,.8,17.2,1.7,25.9,2.8,89.5,37.5,175.6,93.5,256.6,161.1,238.5,198.9,433.1,498.1,540.1,718.2,.8,1.8,.1,3.9-1.7,4.7-1.7,.9-3.8,.1-4.7-1.6-106.6-219.5-300.6-517.7-538.2-715.9-87.5-73.1-180.9-132.5-278-169.3Zm167.9,24.5c7.3,1.4,14.5,2.9,21.9,4.4,55.5,32.3,109.2,71.3,160.8,115.2,235.1,199.9,425.3,500.5,529,721.5,.8,1.7,.1,3.8-1.7,4.6-1.7,.8-3.8,.1-4.6-1.7-103.4-220.3-293-519.9-527.1-719.1-57.1-48.4-116.7-90.9-178.3-124.9Z",
    style: {
      fill: "#85bf63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39,2421.14c10.3-3.2,20.8-6.3,31.4-9.3,95.6,50.7,227.8,55.1,355,59.4,158.1,5.3,308.8,10.4,381,102.4l-18.6,14.5c-65.5-83.4-210.7-88.3-363.2-93.4-139.1-4.6-284-9.5-385.6-73.6Z",
    style: {
      fill: "#0cf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.59,2691.84s210.1-31.5,526.2-156.1c895.2-353,1275.7,507,1930.6,507v386.1H579.49l-40.9-737Z",
    style: {
      fill: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2153.09,2676.54c275.9,167.3,527.4,366.2,842.3,366.2v201.4H1598.49v-350.9c226.2-33.7,396.7-123.3,554.6-216.7Z",
    style: {
      fill: "#408a67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.59,2691.84s149.8-22.5,386.7-104.5c390.3,103.6,717,312.1,758.6,411.1v430.4H579.49l-40.9-737Z",
    style: {
      fill: "#408a67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.09,2654.04c4.2-1.1,8.4-2.3,12.7-3.5,247.9,92.4,608.5,179.2,932.8,162.1,182.1-9.6,352.7-52,485.2-144.6,2.4,1.5,4.8,2.9,7.3,4.4-134.2,94.9-307.3,138.2-492,148-329.9,17.3-697.1-72.4-946-166.4Zm119.1-34.4c4.2-1.3,8.3-2.6,12.5-3.9,241.7,80.8,561.5,148.9,852,133.6,150.8-7.9,293.7-38.4,413.5-101.1,2.6,1.5,5.3,3,7.8,4.6-121.8,64.8-267.3,96.1-420.9,104.2-295.6,15.4-621.4-55-864.9-137.4Zm115.7-38.5c4-1.4,8.1-2.8,12.2-4.3,230.2,69.4,514.1,122.7,774.7,109,117.1-6.2,229.4-25.9,329.9-63.8,2.9,1.6,5.8,3.2,8.7,4.8-102.8,39.7-218,60.2-338.2,66.6-265.3,14.1-554.8-41.2-787.3-112.3Zm112.3-41.7c3.2-1.2,6.4-2.5,9.6-3.7,.8-.3,1.7-.6,2.4-.9,215.3,58.6,467.4,100,700.5,87.7,79.9-4.2,157.7-14.7,230.9-33.1,3.4,1.8,6.9,3.5,10.3,5.3-76.2,19.7-157.3,31-240.8,35.4-237.6,12.5-494.7-30.5-712.9-90.7Zm120.4-42c4.8-1.5,9.8-3,14.6-4.4,195.1,46.7,412.5,76.7,615.6,66,36.8-1.9,73.2-5.2,108.9-10,4.4,1.9,8.9,3.9,13.2,5.9-39.7,5.7-80.5,9.6-121.7,11.8-208.4,11-431.7-20.8-630.6-69.3Zm161.7-36.1c8.1-1.2,16.2-2.1,24.2-3.2,136.8,25.6,279.9,41.3,418.4,39.6,7.4,2.4,14.8,4.8,22.2,7.3-153.5,3.9-313.5-14-464.8-43.7Zm824.9,220.8l6.9,4.2c-140.3,129.6-338.9,186.1-553.1,197.3-338.5,17.9-716.3-77-965.2-173.7-2-.8-3-3-2.2-5,.8-1.9,3-2.9,5-2.1,248.2,96.4,624.8,191,962,173.2,211.8-11.2,407.9-66.7,546.6-193.9Zm14.3,8.7c2.2,1.4,4.4,2.8,6.6,4.1-140.6,168.8-362.8,239.4-605.1,252.1-338.5,17.9-716.3-77-965.2-173.7-1.9-.8-3-3-2.1-5,.8-2,3-3,4.9-2.2,248.2,96.5,624.8,191,962.1,173.2,239.8-12.6,459.7-82.1,598.8-248.5Zm-1613.4,441.7l-.4-8.2c236.9,80.3,543.4,147,822.9,135,241.5-10.4,462.8-79.7,601.4-250.2,1.3-1.7,3.7-1.9,5.4-.6,1.7,1.3,1.9,3.7,.6,5.3-140.1,172.5-363.5,242.6-607,253.1-279.5,12.1-585.6-54.4-822.9-134.4Zm-3.9-69.8l-.4-8.3c243.3,83,570.1,154.1,866.6,138.5,242.9-12.8,465.3-83.9,604.1-254.7,1.3-1.7,3.7-1.9,5.3-.6,1.7,1.4,1.9,3.8,.6,5.4-140.4,172.8-364.8,244.8-609.7,257.7-296.2,15.5-622.7-55.2-866.5-138Zm-4.3-78.2l-.5-8.3c246.8,89,595,169.9,909,153.4,243-12.8,465.4-83.9,604.1-254.8,1.3-1.7,3.7-1.9,5.4-.6s1.9,3.7,.6,5.4c-140.4,172.8-364.8,244.7-609.7,257.7-313.8,16.4-661.6-63.9-908.9-152.8Zm-4.4-79.1l-.4-8.4c248.2,95,619,186.6,951.4,169.2,243-12.8,465.4-84,604.1-254.8,1.3-1.7,3.7-1.9,5.4-.6,1.7,1.3,1.9,3.7,.6,5.4-140.4,172.8-364.7,244.7-609.7,257.6-332.3,17.5-702.4-73.6-951.4-168.4Zm1599.1-152.6c1.3-1.7,1-4.1-.6-5.4-1.7-1.3-4.1-1-5.4,.6-138.8,170.9-361.2,242-604.1,254.8-337.3,17.8-713.9-76.8-962.1-173.2-1.9-.8-4.2,.2-5,2.1-.8,2,.2,4.2,2.2,5,248.9,96.7,626.8,191.5,965.2,173.7,245-12.9,469.5-84.8,609.8-257.6Z",
    style: {
      fill: "#408a67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.89,2464.44c19-3.2,37.9-5.8,56.5-7.9-23.2,7.3-37.9,16-45.4,25-4.2,5-5.9,10-5.4,14.7,.6,5.2,3.7,10.5,8.9,15.8,13.2,13.4,38.4,24.9,71.5,31,8.3,1.6,26,3,48.9,4.9,85.7,7.1,241,19.9,284,71.9,23.1,28,17.1,64.5-40.9,112.5-130,107.6-497.4,134.9-498.5,135l-1.5-19.8c1-.1,362.1-26.9,487.3-130.5,46.8-38.8,53.8-65.7,38.3-84.5-37.7-45.5-187.7-58-270.3-64.7-23.1-1.9-41.1-3.4-50.9-5.3-37.2-6.9-66.2-20.4-82.1-36.6-8.3-8.4-13.4-17.8-14.4-27.5v-.1c-1.1-10.1,2-20.1,10-29.6,1.1-1.5,2.5-2.9,4-4.3Z",
    style: {
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3530.99,2607.94c-152.7-84.5-327-165.4-468.4-188.2-619.4-100.2-828.3,384-1429,473.4v350.9h1897.4v-636.1Z",
    style: {
      fill: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3103.79,2427.84c-6.9-1.6-13.8-3-20.6-4.4-84.3,1.5-180.8-1.9-282.4-11.8-10.2,1.1-20.1,2.5-30.1,3.9,119.8,13.1,233.4,17,329.9,14.5,1.5,.1,2.8-.9,3.2-2.2Zm-483.1,24c-4.6,1.5-9.1,3.1-13.6,4.6,182.9,33.4,363.7,43.9,506.8,40.2,1.9-.1,3.5-1.7,3.5-3.6-.1-1.9-1.7-3.5-3.7-3.5-139.5,3.7-315-6.2-493-37.7Zm-106.2,41.9c-3.5,1.6-6.9,3.2-10.4,4.8,220.7,52.7,449.6,69,623,64.5,1.9-.1,3.5-1.7,3.4-3.7-.1-1.9-1.7-3.5-3.6-3.4-170.7,4.5-395.2-11.3-612.4-62.2Zm-83.5,41.3c-3,1.5-6,3.1-8.9,4.7,248.2,72.7,519.6,94.9,718,89.7,1.9-.1,3.5-1.7,3.5-3.6-.1-1.9-1.7-3.5-3.6-3.5-196,5.2-463.4-16.4-709-87.3Zm-71.4,39.7c-2.7,1.5-5.3,3-8,4.6,269.3,94.2,580.8,122.4,801.9,116.6,1.9-.1,3.5-1.7,3.4-3.7-.1-1.9-1.7-3.5-3.6-3.4-219,5.7-526.7-21.9-793.7-114.1Zm-63.8,37.5l-7.5,4.5c284.9,117.5,635.9,151.9,878.3,145.6,1.9-.1,3.5-1.7,3.5-3.6-.1-1.9-1.7-3.5-3.7-3.4-240.2,6.3-587.5-27.7-870.6-143.1Zm-58.1,34.9l-7.2,4.3c20.6,10,41.6,19.5,63.1,28.5,286.4,120.1,641.6,155.2,886.2,148.9,1.9-.1,3.5-1.7,3.4-3.7-.1-1.9-1.7-3.5-3.6-3.4-243.9,6.4-598-28.7-883.3-148.4-19.9-8.3-39.4-17-58.6-26.2Zm-53.4,31.9l-7.1,4.1c41,23.3,84.4,44.3,129.5,63.3,286.4,120.1,641.7,155.2,886.2,148.9,1.9-.1,3.5-1.7,3.5-3.6-.1-1.9-1.7-3.5-3.7-3.4-243.8,6.3-597.9-28.7-883.3-148.4-43.5-18.4-85.4-38.6-125.1-60.9Zm-49,28.4c-2.3,1.2-4.6,2.6-6.9,3.9,58.2,39.1,122.9,72.8,191.5,101.5,286.4,120.1,641.6,155.2,886.2,148.9,1.9-.1,3.5-1.7,3.4-3.6-.1-2-1.7-3.5-3.6-3.5-243.9,6.4-598-28.7-883.3-148.3-67-28.2-130.2-60.9-187.3-98.9Zm-48,26.7c-2.2,1.2-4.5,2.4-6.7,3.6,72.8,58.6,159.3,106.3,253.2,144.6,285.7,116.7,640,147.2,883.9,137.6,1.9-.1,3.5-1.7,3.4-3.7s-1.7-3.4-3.7-3.3c-243.2,9.6-596.4-20.8-881-137.1-92.3-37.7-177.4-84.5-249.1-141.7Z",
    style: {
      fill: "#88c163"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "3498.59 2641.24 3363.39 2043.94 3228.29 2641.24 3498.59 2641.24",
    style: {
      fill: "#568a5c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3530.99 2168.54 3496.29 2015.34 3354.69 2641.24 3530.99 2641.24 3530.99 2168.54",
    style: {
      fill: "#2a5254"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3312.49 2641.24 3197.39 2132.24 3082.19 2641.24 3312.49 2641.24",
    style: {
      fill: "#568a5c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3201.79 2767.24 3096.89 2303.54 2991.99 2767.24 3201.79 2767.24",
    style: {
      fill: "#366541"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3228.09 2707.44 3152.19 2371.94 3076.29 2707.44 3228.09 2707.44",
    style: {
      fill: "#2a5254"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3015.09 2810.34 2939.89 2477.74 2864.59 2810.34 3015.09 2810.34",
    style: {
      fill: "#18413d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2942.29 2856.84 2869.89 2536.94 2797.49 2856.84 2942.29 2856.84",
    style: {
      fill: "#568a5c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2837.09 2881.44 2775.49 2608.94 2713.79 2881.44 2837.09 2881.44",
    style: {
      fill: "#366541"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2782.69 2899.84 2727.19 2654.54 2671.69 2899.84 2782.69 2899.84",
    style: {
      fill: "#2a5254"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2652.09 2927.04 2598.39 2689.64 2544.59 2927.04 2652.09 2927.04",
    style: {
      fill: "#2a5254"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2507.39 2942.24 2474.09 2795.34 2440.79 2942.24 2507.39 2942.24",
    style: {
      fill: "#34635b"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3530.99,2510.14c-336.7,103-1046.72,526.46-1847.1,488.3l541.08,771.94,1308.68,181.5-2.66-1441.74Z",
    style: {
      fill: "url(#j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3530.99,2677.04c-44.5,41-70,103.4-85.3,188.1-29.1,160.8-219.1,197.1-219.1,197.1l304.4,236.3v-621.5h0Z",
    style: {
      fill: "url(#k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3530.99,2660.44c-21.4,20.2-42.2,41.5-62.5,63.8-155,170.3-276.6,395.3-356,590h7.1c79.1-193.5,200-416.6,353.7-585.6,18.8-20.6,37.9-40.3,57.6-59.1v-9.1h.1Zm0-119v7.9c-65.4,43.4-126.7,98.5-183.5,160.9-158.7,174.4-282.2,406.3-361.2,604h-7.1c79.1-198.8,203.4-432.7,363.3-608.4,58.3-64,121.3-120.2,188.5-164.4Zm0,55v8.5c-42.1,34-82.3,72.6-120.6,114.6-156.2,171.7-278.4,399.2-357.4,594.8h-7.1c79.3-196.8,202.3-426.2,359.6-599.2,39.7-43.7,81.6-83.7,125.5-118.7Zm0,137.6v9.8c-148.8,165.6-266.3,381.3-344.6,570.4h-7.1c79.4-192.3,199.4-412.6,351.7-580.2Zm0,83.6v10.7c-117,149.7-211.1,326.8-277.7,485.9h-7.1c67.8-162.7,164.5-344.2,284.8-496.6Zm0,94.5v11.6c-86,125.8-157.1,263.5-210.9,390.5h-7.1c55.1-130.7,128.7-273,218-402.1Zm-30.9-392.1c-9.3,3.1-18.6,6.3-28,9.6-68.8,44.5-133.1,101.8-192.5,167.1-162.4,178.5-288.1,416.9-367,617.6h7.1c78.7-199.6,203.6-436.1,364.8-613.1,66.1-72.6,138.1-135.2,215.6-181.2Zm-167.7,65.2c-7.1,3-14.1,6.2-21.2,9.3-32.8,28.5-64.3,59.6-94.6,92.9-164.8,181.2-291.9,424.2-370.6,626.9h7.1c78.5-201.6,204.8-442.5,368.4-622.4,35.3-38.8,72.3-74.6,110.9-106.7Zm-145.1,67c-5.7,2.8-11.4,5.5-17,8.2-5.5,5.9-11.1,11.8-16.5,17.9-167.4,183.9-295.7,431.5-374.1,636h7.1c78.2-203.4,205.9-449,372-631.6,9.2-10.4,18.8-20.6,28.5-30.5Zm-127.1,61.9l-14.5,7.1c-147.8,179.8-261.6,405.6-332.6,593.1h7.1c72.3-190.5,188.7-420,340-600.2Zm-113.8,54.8c-4.2,2-8.4,3.9-12.7,6-126.4,170.8-224.3,371.2-287.1,539.4h7.1c63.9-170.5,163.7-373.8,292.7-545.4Zm-103.6,47.2c-3.8,1.7-7.6,3.3-11.4,5-109.7,160.9-195,340.9-251.1,493.1h7c57-154.1,143.8-336.3,255.5-498.1Zm-95.3,39.6c-3.5,1.4-6.9,2.6-10.2,3.9-94.2,151.4-167.4,315.2-216.1,454.6h7c49.3-140.8,123.6-306.3,219.3-458.5Z",
    style: {
      fill: "#88c163"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.99,2600.34c630.9-258.5,1531.9,229.1,1602.7,398.1v561.6H30.99v-959.7Z",
    style: {
      fill: "url(#l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1346.69,2773.24c75.71,40.85,485.86,313.61,891.92,590.57,433.81,295.9,1283.37,560.17,1295.04,588.07l9.91,1148.13-3514.41-11.03,1.83-1896.93c481.7-278.7,914.8-399.8,1315.7-418.8Z",
    style: {
      fill: "#317664"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.79,2562.44c21.4-5.7,43-10.7,64.8-15-62.3,24.3-121.8,55.3-178.6,92.2v-14.2c36.8-23.5,74.7-44.6,113.8-63ZM30.99,3559.94v-16.8c70.4-158.8,152.5-313.3,246.8-453.1,150.1-222.8,331.1-408.5,544.8-515.9,6.1,1.5,12.2,2.8,18.2,4.4-217.3,105.3-401.1,292.6-553.1,518.1-96.3,142.8-179.8,300.9-251.1,463.3h-5.6Zm0-226.2v-25.3c41-75.6,84.9-148.9,131.8-218.5,158.4-235.1,351.3-428.8,580.6-532.9,6.8,1.3,13.6,2.6,20.4,4-233.9,101.3-430.2,297-591.1,535.5-50.7,75.5-97.9,155-141.7,237.2Zm0-196.4v-21.9c5.6-8.5,11.2-17,16.9-25.4,165.9-246.1,369.5-447,613.1-547,7.8,1.1,15.5,2.4,23.3,3.6-249.5,96.2-457.6,299.5-626.4,550-9.2,13.5-18.1,27-26.9,40.7Zm0-162.2v-19.3c152.7-192.4,332.8-344.8,541.7-423.2,9.2,.8,18.3,1.7,27.5,2.8-221,76.3-410.2,236.1-569.2,439.7Zm0-133.4v-17.2c130.3-134.4,277.7-239.1,442.8-297.7,11.3,.3,22.6,.6,33.9,1.2-179.2,56.7-337.7,168.1-476.7,313.7Zm0-108.5v-15.5c98.5-81.8,205.7-146.6,321.6-188.7,14.4-1,28.9-1.7,43.4-2.1-132.8,41.5-254.4,113.1-365,206.3Zm868.9-139.1c5.5,1.5,11,3,16.5,4.6-200.2,108.2-370.9,286.2-513.8,498-96.2,142.8-179.8,300.9-251.1,463.3h-12.9c72-164.7,156.6-325.2,254.1-470,141.2-209.5,309.8-386.3,507.2-495.9Zm76,22.7c5.1,1.6,10.1,3.2,15.2,4.8-182.9,109.5-340.4,277.6-473.5,475.1-96.2,142.8-179.8,300.9-251.1,463.3h-13c72-164.7,156.6-325.2,254.2-470,131.8-195.6,287.5-362.7,468.2-473.2Zm75.2,25.4c4.6,1.7,9.3,3.4,14,5.1-165.7,109.3-309.6,266.8-432.7,449.4-96.2,142.8-179.8,300.9-251.1,463.3h-13c72-164.7,156.6-325.2,254.2-470,122.2-181.2,264.7-337.8,428.6-447.8Zm74.7,28.2c4.4,1.7,8.7,3.5,13,5.3-148.4,107.4-278.6,253.6-391.4,420.9-96.3,142.8-179.8,300.9-251.1,463.3h-13c72-164.7,156.6-325.2,254.2-470,111.9-166.1,241.2-311.6,388.3-419.5Zm74.2,31.2c4.2,1.9,8.2,3.7,12.3,5.5-131.4,103.8-247.8,238.1-350,389.6-96.2,142.8-179.8,300.9-251.1,463.3h-12.9c72-164.7,156.6-325.2,254.1-470,101.5-150.7,217.2-284.4,347.6-388.4Zm73.8,34.2c3.9,1.9,7.8,3.9,11.6,5.7-114.4,98.3-217,219.8-308.2,355.1-96.2,142.8-179.8,300.9-251.1,463.3h-13c72-164.7,156.6-325.2,254.2-470,90.8-134.5,192.8-255.6,306.5-354.1Z",
    style: {
      fill: "#61b76c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.19,2661.64c35.5,13.8,69.9,28.1,103,42.8-140.3-22.8-374-27.6-711.9,68-193.5,54.7-345.7,86.3-463.3,104v-31.9c115.2-17.7,264.4-49,454.7-102.8,267.2-75.6,471.6-89.1,617.5-80.1Z",
    style: {
      fill: "url(#m)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain04Landscape);
export default __webpack_public_path__ + "static/media/mountain-04-landscape.00d49e9eff151002d84a619849b94e43.svg";
export { ForwardRef as ReactComponent };